<template>
    <div id="app">
        <keep-alive include="index">
            <router-view></router-view>
        </keep-alive>
        <!--<div class="popBG"-->
             <!--@click="this.$store.commit('msgHide')"-->
             <!--v-show="this.$store.getters.msgState">-->
            <!--<div class="popBox">-->
                <!--<div class="popmsg">{{msgContent}}</div>-->
                <!--<div class="popBtn" @click="msg_Hide(0)">回首页</div>-->
                <!--<div class="popBtn" @click="msg_Hide(1)">去登录</div>-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import sa from 'sa-sdk-javascript'
    import wx from 'weixin-js-sdk'

    export default {
        name: 'App',
        data() {
            return {
                token: "",
                goLogin: false,
                msgShow: false,
                msgContent: "",
                page_show: 1,
            }
        },
        methods: {
            msg_Hide(val) {
                var that = this;
                that.$store.commit('msgHide')
                that.msgContent = '';

                if (val == 0) {
                    that.$router.push({path: '/index'})
                }
                else {
                    if (that.goLogin) {
                        that.clearCookie('token')

                        that.goAppLogin();

                        // window.location.reload();
                    }
                }
            },
            msg_Show(val) {
                var that = this;
                that.$store.commit('msgShow')
                that.msgContent = val;
            },
            appStyle(val) {
                var bd = document.getElementById('app');

                if (val == '/index' ||
                    val == '/indexitem' ||
                    val == '/coldlege/detail' ||
                    val == '/masterCourse/detail' ||
                    val == '/column/detail') {
                    bd.style.height = 'inherit';
                }
                else {
                    bd.style.height = '';
                }
            }
        },
        components: {},
        created() {
            let that = this;
            var request = that.getRequest();
            that.token = request.token;

            if (that.token) {
                that.setCookie('token', that.token, 1000 * 60 * 60 * 24 * 2);
            }

            // alert('get_token:'+getCookie('token'))

            if (request.applet_login == "1") {
                //小程序中返回到该页面时，返回最后一次进入的页面
                var backPage = that.getCookie('backPage');

                if (backPage && backPage != '1') {
                    that.delCookie('backPage');
                    window.location.href = backPage;
                    return;
                }
            }

            //then响应数据前，判断是否返回成功
            that.$http.interceptors.response.use(function (response) {
                    return response;
                },
                function (error) {
                    // 对响应错误做点什么
                    return Promise.reject(error);
                }
            );
        },
        updated() {
        },
        beforeMount() {

        },
        watch: {
            '$route'(to, from) {
                var that = this;
                that.appStyle(to.path);

                wx.miniProgram.postMessage({})

                //让小程序知道目前的页面路由 (课程详情)
                if (that.$router && that.$router.history.current.path == "/column/detail") {
                    wx.miniProgram.postMessage({data: {page_path: "/column/detail"}})
                }
            }
        }
    }
</script>
<style src="./assets/font/iconfont.css"></style>
<style lang="less">
    body .pri_display{
        /*display: none !important*/
    }

    .layer-main .app-link {
        display: none !important;
    }

    body {
        -webkit-overflow-scrolling: touch;
    }

    .code-bg {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        z-index: 0;
        top: 0;
        left: 0;
        display: none;
    }

    .router-fade-enter-active, .router-fade-leave-active {
        transition: opacity .3s;
    }

    .router-fade-enter, .router-fade-leave-active {
        opacity: 0;
    }

    html, body {
        // height: 100%;
        position: relative;
        background: #fff;
    }

    body {
        max-width: 800px !important;
        margin: 0 auto !important;
    }

    .buy {
        max-width: 800px !important;
        margin: 0 auto !important;
    }

    * {
        margin: 0;
        padding: 0;
        // color: #333;
        box-sizing: border-box;
        font-style: initial;
    }

    .null-data {
        font-size: 30px !important;
    }

    li {
        list-style: none;
    }

    a {
        color: #333;
        text-decoration: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .container {
        height: 100%;
        position: relative;
        width: 100%;
        -padding: 20px 30px 0;
        /*background: #f1f1f1;*/
    }

    .rel {
        position: relative;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        position: relative;
        height: 100%;
        overflow-x: hidden;
        z-index: 10;
    }

    .tab {
        height: 92px;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        font-size: 0;
        color: #979797;
        background: #fff;
        border-top: 2px solid #f1f1f1;
    }

    .tab li {
        width: 33.3333%;
        display: inline-block;
        text-align: center;
        font-size: 10px;
        padding-top: 10px;
    }

    .footer_icon {
        width: 40px;
        height: 40px;
    }

    .wx-share-bg {
        width: 100%;
        position: fixed;
        z-index: 1000;
        left: 0;
        top: 0;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    .wx-point {
        width: 100%;
        vertical-align: top;
    }

    .wx-wrap {
        position: relative;
        p {
            text-align: center;
            line-height: 80px;
            font-size: 32px;
            color: #fff;
            position: relative;
            z-index: 2;
        }
        img {
            width: 300px;
            height: 96px;
            position: absolute;
            left: 50%;
            -webkit-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            -o-transform: translateX(-50%);
            transform: translateX(-50%);
            top: 0;
        }
    }

    .pc-fix {
        background: #fff !important;
        max-width: 675px !important;
        margin: 0 auto !important;
    }

    .pc-fix-transform {
        transform: translateX(-50%) !important;
        width: 675px !important;
        left: 50% !important;
    }

    .pc-app {
        background: #fff !important;
        max-width: 675px !important;
        margin: 0 auto !important;
    }

    .pc-fm-img {
        width: 190px !important;
        height: 190px !important;
    }

    .qcode {
        -width: 280px;
        -height: 280px;
        position: fixed;
        top: 50%;
        left: 50% !important;
        transform: translate(-50%, -50%);
        z-index: 100;
        -background: red;
        padding: 20px;
        background: #fff;
        border-radius: 10px;
    }

    .q-code-wrap {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        z-index: 100;
    }

    .code-btn {
        padding: 20px 0 0;
        background: #fff;
        color: #ff5266;
        text-align: center;
        font-size: 0.4rem;
    }

    .pc-column-summary {
        width: 420px !important;
    }

    .pc-column-explain {
        width: 420px !important;
    }

    .pc-emotion-header {
        width: 675px !important;
    }

    .pc-html {
        background: #ddd;
    }

    .pc-body {
        background: #ddd;
    }

    .pc-wrapper {
        height: 100% !important;
        background: #fff;
    }

    .pc-fix > div {
        background: #fff;
    }

    .pc-fm-title {
        font-size: 30px !important;
        width: 340px !important;
    }

    .testListItem {
        cursor: pointer;
    }

    .popBG {
        background: rgba(0, 0, 0, .3);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 1001;
        .popBox {
            border-radius: 10px;
            background: #fff;
            position: relative;
            top: 30%;
            width: 370px;
            height: 250px;
            margin: 0 auto;
            padding-top: 30px;
            .popmsg {
                width: 90%;
                height: 100px;
                margin: 0 auto;
                text-align: center;
                font-size: 28px;
                margin-top: 20px;
                letter-spacing: 3px;
            }
            .popBtn {
                font-size: 28px;
                float: right;
                margin-right: 66px;
                color: #f8485e;
            }
        }
    }

    .wrapper {
        height: 86vh !important;
    }

    @media screen and (min-width: 600px) {
        html {
            background: #f9f9f9;
        }

        #app {
            background-color: #fff;
            height: 100vh !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue